import { render, staticRenderFns } from "./addInviteItem.vue?vue&type=template&id=5d8d9540&scoped=true&"
import script from "./addInviteItem.vue?vue&type=script&lang=js&"
export * from "./addInviteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8d9540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8d9540')) {
      api.createRecord('5d8d9540', component.options)
    } else {
      api.reload('5d8d9540', component.options)
    }
    module.hot.accept("./addInviteItem.vue?vue&type=template&id=5d8d9540&scoped=true&", function () {
      api.rerender('5d8d9540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/hdcommunication/components/addInviteItem.vue"
export default component.exports